import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ConfirmationEnum } from './confirmation.enum';
import { ConfirmationTheme, ConfirmationThemeEnum, THEMES } from './theme';

@Component({
  templateUrl: './confirmation.component.html',
  styleUrls: ['./confirmation.component.scss']
})
export class ConfirmationComponent {
  public confirmationEnum = ConfirmationEnum;
  public title: string;
  public question: string | string[];
  public isQuestionArray: boolean;
  public theme: ConfirmationTheme;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    { title, question, theme }: { title: string; question: string | string[]; theme: ConfirmationThemeEnum }
  ) {
    this.title = title;
    this.isQuestionArray = Array.isArray(question);
    this.question = question;
    this.theme = THEMES[theme] ? THEMES[theme] : THEMES.default;
  }
}
